export default __webpack_public_path__ + "static/media/NPPD.5f8c5066.svg";